import { render, staticRenderFns } from "./riskDetailAppr.vue?vue&type=template&id=d44517a8"
import script from "./riskDetailAppr.vue?vue&type=script&lang=js"
export * from "./riskDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d44517a8')) {
      api.createRecord('d44517a8', component.options)
    } else {
      api.reload('d44517a8', component.options)
    }
    module.hot.accept("./riskDetailAppr.vue?vue&type=template&id=d44517a8", function () {
      api.rerender('d44517a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/ram/riskDetailAppr.vue"
export default component.exports